import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';
import FloatingFAQ from '@/components/FloatingFAQ';
import UniformForm from '@/components/UniformForm';
import { submitContactForm } from '@/services/brevoEmailService';
import { ScrollReveal } from '@/components/ScrollReveal';
import { 
  Mail,
  Phone,
  MapPin
} from 'lucide-react';

const NousContacter = () => {
  const formFields = [
    {
      id: 'nom',
      label: 'Nom',
      type: 'text' as const,
      required: true
    },
    {
      id: 'email',
      label: 'Email',
      type: 'email' as const,
      required: true
    },
    {
      id: 'sujet',
      label: 'Sujet',
      type: 'text' as const
    },
    {
      id: 'message',
      label: 'Message',
      type: 'textarea' as const,
      required: true,
      rows: 6
    }
  ];

  const handleSubmit = async (data: Record<string, string>) => {
    await submitContactForm(data, data.email);
  };
  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      
      {/* Hero Section */}
      <section className="bg-primary text-primary-foreground py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl lg:text-5xl font-bold mb-6">
            Nous contacter
          </h1>
          <p className="text-xl lg:text-2xl text-primary-foreground/90">
            Une question ? Un projet ? Contactez-nous !
          </p>
        </div>
      </section>

      {/* Contact Content */}
      <section className="py-16">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Contact Info */}
            <div>
              <h2 className="text-2xl font-bold text-foreground mb-8">
                Nos coordonnées
              </h2>
              
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <Mail className="h-6 w-6 text-primary" />
                  </div>
                  <div>
                    <h3 className="font-semibold mb-1">Email</h3>
                    <p className="text-muted-foreground">laudare.iledere@gmail.com</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <Phone className="h-6 w-6 text-primary" />
                  </div>
                  <div>
                    <h3 className="font-semibold mb-1">Téléphone</h3>
                    <p className="text-muted-foreground">07 66 47 77 46</p>
                    <p className="text-sm text-muted-foreground/80 mt-1">Disponible tous les jours de 9h à 19h</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <MapPin className="h-6 w-6 text-primary" />
                  </div>
                  <div>
                    <h3 className="font-semibold mb-1">Adresse</h3>
                    <p className="text-muted-foreground">
                      SARL LAUDARE<br />
                      30 rue Gambetta<br />
                      17590 Ars-en-Ré, France
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <ScrollReveal>
              <UniformForm
                title="Envoyez-nous un message"
                description="Nous vous répondrons dans les plus brefs délais"
                fields={formFields}
                submitText="Envoyer le message"
                onSubmit={handleSubmit}
              />
            </ScrollReveal>
          </div>
        </div>
      </section>

      <FloatingFAQ />
      <Footer />
    </div>
  );
};

export default NousContacter;